import React from 'react';
import style from '../../css/ChooseUs.module.css';
import { FaGlobeAsia, FaRegClock, FaHeadphonesAlt } from 'react-icons/fa';
import { FaUser, FaUserPlus, FaUsers } from 'react-icons/fa6';

function WhyCard_three() {
	return (
		<section className={style.wrapper}>
			<div className={style.header}>
				<h2 className={style.mainTitle}>Flexible booking options</h2>
				<div className={style.subTitle}>
					<p className={style.emphasis}>
						Trusted Travel Experts with Global Reach
					</p>

					<span>
						Serving both corporate clients and individual travelers with
						reliability, value, and care.
					</span>
				</div>
			</div>
			<div className={style.cards}>
				{/* Global Network */}
				<div className={`${style.card} ${style.purple}`}>
					<FaUsers className={style.icon} />
					<h3 className={style.cardTitle}>Streamline group events</h3>

					<p className={style.cardText}>
						Plan events of any size while maintaining spend control and
						visibility.
					</p>
				</div>
				{/* Fast Booking & Support */}
				<div className={`${style.card} ${style.white}`}>
					<FaUser className={style.icon} />
					<h3 className={style.cardTitle}>Seamless guest booking</h3>

					<p className={style.cardText}>
						Give company guests an intuitive, seamless travel booking experience
						with built-in spend controls.
					</p>
				</div>
				{/* 24/7 Support */}
				<div className={`${style.card} ${style.green}`}>
					<FaUserPlus className={style.icon} />
					<h3 className={style.cardTitle}>Executive travel management</h3>

					<p className={style.cardText}>
						Book for others while keeping their preferences and loyalty benefits
						in mind.
					</p>
				</div>
			</div>
		</section>
	);
}

export default WhyCard_three;
